import React from 'react';
import SanityImage from 'gatsby-plugin-sanity-image';
import { Flex, Box } from '@chakra-ui/react';
import { RichText } from '../RichText';

export default function InlineImage({ data }) {
  const { image, alignment, caption } = data || {};
  return (
    <Flex
      flexDirection='column'
      alignItems={alignment || 'left'}
      justifyContent={alignment || 'left'}
      as='figure'
    >
      <Box
        as={SanityImage}
        {...image}
        alt={image?.asset?.altText || ''}
        width={`${image.asset.width}px`}
        height='auto'
      />
      {caption && (
        <RichText
          as='figcaption'
          textStyle='body'
          fontSize='1rem'
          lineHeight='1.1'
          textAlign={alignment || 'left'}
          value={caption}
        />
      )}
    </Flex>
  );
}
